import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ShowcaseCaseStories } from 'commerce/models';
import { CardGridComponent, CardSliderComponent } from '@sirius/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'commerce-showcase-case-stories',
    templateUrl: './showcase-case-stories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./showcase-case-stories.component.scss'],
    imports: [CardGridComponent, CardSliderComponent, TranslatePipe]
})
export class ShowcaseCaseStoriesComponent implements OnInit {
    config?: ShowcaseCaseStories;

    MINIMUM_SLIDER_ITEMS_ALLOWED_BY_UX = 3;

    @Input()
    caseStoryItems: ShowcaseCaseStories = { caseStoryItems: [], componentName: '' };

    ngOnInit(): void {
        if (this.config?.caseStoryItems) {
            this.caseStoryItems = this.config;
        }
    }
}
